import {
  ChangeDetectionStrategy,
  ChangeDetectorRef,
  Component,
  EventEmitter,
  Input,
  OnChanges,
  Output
} from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { switchMap } from 'rxjs/operators';
import { combineLatest } from 'rxjs';

import { IRecipeCard } from '@seb/web-design-system/recipe-card';
import {
  BrandsEnum,
  BrandThemesEnum, IComponentWrapper,
  IHeading,
  SdComponentWrapperComponent,
  SizesEnum
} from '@seb/web-design-system/core';
import {
  BaseRecipeListComponent
} from '@seb/web-common/core/components/base/base-recipe-list/base-recipe-list.component';
import { DcpListResponse, PdpConfig, RecipeSearchItem } from '@seb/web-common/core/models';
import { BrandCornerMapper, HeadingParagraphMapper, toHeading } from '@seb/web-common/core/mappers';
import { RecipeService } from '@seb/web-common/core/services';

@Component({
  selector: 'wc-product-recipe-list',
  templateUrl: './product-recipe-list.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: true,
  imports: [SdComponentWrapperComponent, BaseRecipeListComponent]
})
export class ProductRecipeListComponent implements OnChanges {
  recipesCard: IRecipeCard[];
  totalCount: number;
  heading: IHeading;
  wrapperContent: IComponentWrapper;
  lameConfig: PdpConfig;

  @Input()
  productCode: string;

  @Input() brand = BrandsEnum.default;

  @Output()
  hasRecipes = new EventEmitter<boolean>();

  constructor(
    private recipeSearch: RecipeService,
    private translateService: TranslateService,
    private cdRef: ChangeDetectorRef,
    private headingParagraphMapper: HeadingParagraphMapper,
    private brandCornerMapper: BrandCornerMapper
  ) {}

  ngOnChanges(): void {
    this.lameConfig = this.brandCornerMapper.toWcConfig(this.brand)?.pdp;
    this.heading = toHeading({ headline: this.translateService.instant('recipes.list.title') });
    const richParagraphData = {
      heading: {
        headline: this.translateService.instant('recipes.list.title')
      },
      titleTheme: this.lameConfig?.recipes?.titleTheme || BrandThemesEnum.brand,
      isUnderlined: !!this.lameConfig?.recipes?.titleUnderlined,
      size: SizesEnum.l
    };
    this.wrapperContent = {
      titleLevel: 2,
      links: [],
      footNotes: [],
      heading: this.headingParagraphMapper.toHeadingParagraph(richParagraphData)
    };
    if (this.productCode) {
      this.recipeSearch
        .search('', 0, 3, {}, this.productCode)
        .pipe(
          switchMap((recipes: DcpListResponse<RecipeSearchItem>) => {
            this.hasRecipes.emit(recipes.content?.length > 0);
            return combineLatest(
              recipes?.content?.map((item: RecipeSearchItem) => this.recipeSearch.extractRecipeSearchItem(item))
            );
          })
        )
        ?.subscribe((results: IRecipeCard[]) => {
          if (results) {
            this.recipesCard = results;
            this.totalCount = this.recipesCard?.length > 0 ? this.recipesCard?.length : 0;
          }
          this.cdRef.markForCheck();
        });
    }
  }
}
